export enum InsightCategoryColor {
    TEAL = "teal",
    PINK = "pink",
    ORANGE = "orange",
    GREEN = "green",
}

export type InsightTier = 1 | 2 | 3 | 4;

// Keep the palette order stable so categories retain their colors across visits and surfaces.
export const INSIGHT_CATEGORY_PALETTE = [InsightCategoryColor.TEAL, InsightCategoryColor.PINK, InsightCategoryColor.ORANGE, InsightCategoryColor.GREEN] as const;

export function colorForExperimentSlug(slug: string | null | undefined): InsightCategoryColor {
    let hash = 2166136261;
    for (const character of slug ?? "") {
        hash = Math.imul(hash ^ character.codePointAt(0)!, 16777619);
    }
    return INSIGHT_CATEGORY_PALETTE[(hash >>> 0) % INSIGHT_CATEGORY_PALETTE.length];
}

export const TIER_LABELS: Record<InsightTier, string> = {
    1: "Calendar",
    2: "Perspective",
    3: "Collaboration Profile",
    4: "Work IQ",
};

export const MYWORK_CTA_SOURCES = {
    ACTIVATOR: "activator",
    PREVIEW_CARD: "preview_card",
} as const;
